export enum AnalyticsEvent {
  CONTACT_US_SUBMIT = 'contact_us_submit',
  INTERESTS_SET = 'interests_set',
  NEWSLETTER_SUBMIT = 'newsletter_signup',
  REFERRAL_PROGRAM_ENROLLMENT = 'referral_program_enrollment'
}
